import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardLoadingButton } from "../../../../../shared/components/buttons/LoadingButton"
import { StandardAlertInfo } from "../../../../../shared/components/alert/StandardAlertInfo"

import { resetProductSort } from "../priceListApi"

const useStyles = makeStyles()(() => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: ".75rem",
        paddingLeft: "1rem",
    },
    info: {
        maxWidth: "36rem",
    },
}))

type Props = Readonly<{
    priceListId: number
    onEnabled: () => void
}>

export function EnableProductSort({ priceListId, onEnabled }: Props) {
    const { classes } = useStyles()

    const { mutate, isLoading } = useApiMutation(resetProductSort, {
        async onSuccess() {
            onEnabled()
        },
    })

    return (
        <Box className={classes.root}>
            <LocalizedStrict id="merchant-admin-enable-product-sort-button">
                <StandardLoadingButton fullWidth={false} loading={isLoading} onClick={() => mutate({ priceListId })}>
                    Enable product sort
                </StandardLoadingButton>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-admin-enable-product-sort-info" attrs={{ title: true }}>
                <StandardAlertInfo
                    className={classes.info}
                    title="When you first enable product sort, we will sort the products and product groups in a default order. From there you can move them around as you wish."
                />
            </LocalizedStrict>
        </Box>
    )
}
